import { render, staticRenderFns } from "./PasswordRecoveryRequest.vue?vue&type=template&id=84bd930c&lang=html&"
import script from "./PasswordRecoveryRequest.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoveryRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports